import React, { useState, useEffect } from "react";

import { isMobileOnly } from 'react-device-detect';

import DateUtil from "../../common/dateUtil";

import ErrorComp from "../common/ErrorComp";
import LoadingComp from "../common/LoadingComp";

import ObaSearchCriteriaComp from "./ObaSearchCriteriaComp";
import ObaGridComp from "./ObaGridComp";
import ObaListComp from "./ObaListComp";

import ObaDetailComp from "./ObaDetailComp";

import { fetchCall } from "../../common/FetchHelpers";

const ObaSearchComp = (props)=>{

  const searchUrl = "api/oba/search";
  const detailUrl = "api/oba/details/";
  
  let initFromDate = new Date(new Date());
  initFromDate.setDate(initFromDate.getDate() - 90);
  
  const fromDateStr = DateUtil.toIsoStrDate(initFromDate);
  
  const initFormData = {
    businessName: "",
    businessType: "",
    businessDesc: "",
    fromDate: fromDateStr,
    toDate: DateUtil.toIsoStrDate(new Date()),
    reqStatus: "APPROVED,PENDING,REJECTED",
  };
  
  const [reloadResult, setReloadResult] = useState(false);
  const [searchCriteria, setSearchCriteria] = useState(initFormData);
  
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  
  const [items, setItems] = useState([]);
  const [currentItem, setCurrentItem] = useState({});
  
  const [dataFrame, setDataFrame] = useState({ startIndex: 0, limit: 10 });
   
  const searchItems = (jsonData) => {
    setLoading(true);
    setSearchCriteria(jsonData);

    const fetchConfig = {
      method: "POST",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json"
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(jsonData),
    };
    fetchCall(searchUrl, fetchConfig)
      .then((result)=>{
        setDataFrame({ startIndex: 0, limit: 10 });
        setItems(result);
        setLoading(false);
        setShowResult(true);
        setReloadResult(false);
      },
      (err) => {
        setLoading(false);
        setShowError(true); 
      }
    );
  };
     
  const onSearch = (criteria) => {
    setShowResult(false);
    searchItems(criteria);
  };


  const detailClickHandler = (id) => {
    setShowResult(false);
    setLoading(true);
    const url = detailUrl + id;
    fetchCall(url)
      .then((result) => {
        result.formData = JSON.parse(result.formData);

        result = {...result, ...result.formData}
        result.isClientOwnSecurity = result.clientAccount?"Yes":"No";
        result.isFundraising = result.fundraisingDesc?"Yes":"No";
        result.isBusinessCustody = result.businessCustody?"Yes":"No";
        result.rdoPartnerType = (result.partnerType === "General" || result.partnerType === "Limited" )?result.partnerType:"Other";

        if(result.solicitedInvestors && result.solicitedInvestors.length>0){
            result.solicitedInvestors.map(p=>p.investmentDate = (p.investmentDate)?new Date(p.investmentDate):"");
        }
        else {
            result.solicitedInvestors = [{investorName:"",investorRelation:"",investmentAmount:"",investmentDate:"",involvementType:""}];
        }

        if(!result.activityInvolvedPeople || result.activityInvolvedPeople.length===0){
            result.activityInvolvedPeople = [{name:"",accountNumbers:"",involvementType:""}];
        }
        
        setLoading(false);
        setCurrentItem(result);
        setShowDetail(true);
      },
      (err) => {
        setLoading(false);
        setShowError(true);
      }
    );

  };

  const handleReloadItem =(id)=>{
    const url = detailUrl + id;

    fetchCall(url)
      .then((result)=>{
        result.formData = JSON.parse(result.formData);
        result = {...result, ...result.formData}
        result.isClientOwnSecurity = result.clientAccount?"Yes":"No";
        result.isFundraising = result.fundraisingDesc?"Yes":"No";
        result.isBusinessCustody = result.businessCustody?"Yes":"No";
        result.rdoPartnerType = (result.partnerType === "General" ||result.partnerTyp === "Limited" )?result.partnerType:"Other";
        
        if(result.solicitedInvestors && result.solicitedInvestors.length>0){
          result.solicitedInvestors.map(p=>p.investmentDate = (p.investmentDate)?new Date(p.investmentDate):"");
      }
      else {
          result.solicitedInvestors = [{investorName:"",investorRelation:"",investmentAmount:"",investmentDate:"",involvementType:""}];
      }

      if(!result.activityInvolvedPeople || result.activityInvolvedPeople.length===0){
          result.activityInvolvedPeople = [{name:"",accountNumbers:"",involvementType:""}];
      }

        console.log(result);
        setCurrentItem(result);
        setReloadResult(true);
      },
      (err)=>{
        console.log(err);
      }
    );

  };

  const handleCloseDetail = () => {
    setShowDetail(false);
    if(reloadResult){
      onSearch(searchCriteria);
    } else{
      setShowResult(true);
    }
  };

  useEffect(() => {
    searchItems(initFormData);
    if(props.obaId){
      detailClickHandler(props.obaId);
    }
  }, []);

  useEffect(() => {
    if(props.obaId){
      detailClickHandler(props.obaId);
    }
  }, [props.t]);


  return (
      <div>
          {!showDetail && <ObaSearchCriteriaComp onSearch={onSearch}/>}
          
          {showResult && !showDetail &&(
              <div>
              {isMobileOnly && <ObaListComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />}
              {!isMobileOnly && <ObaGridComp items={items} dataFrame={dataFrame} setDataFrame={setDataFrame} onDetail={detailClickHandler} />}

              </div>
          )}

          {showDetail && (
                  <ObaDetailComp
                  data={currentItem}
                  title="Details"
                  reloadItem={handleReloadItem}
                  handleUpdate={p=>props.handleUpdate(currentItem)}
                  handleClose={handleCloseDetail}
                  />
              )}

          {showError && <ErrorComp />}
          {loading && <LoadingComp />}

      </div>
  );
}


export default ObaSearchComp;
